import { useSyncExternalStore } from "react";
import {
  getRuntimeHttpClientSnapshot,
  subscribeToRuntimeHttpClient,
} from "@/features/runtime-session/api/runtime-http-client";

/** Reads the current application-wide Runtime API client and its grants. */
export function useRuntimeHttpClient() {
  return useSyncExternalStore(
    subscribeToRuntimeHttpClient,
    getRuntimeHttpClientSnapshot,
    getRuntimeHttpClientSnapshot
  );
}
